import { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import { VERIFY_EMAIL } from '@/graphql/queries';
import { REQUEST_MAGIC_LINK_MUTATION } from '@/graphql/mutation';
import { RequestMagicLinkResponse, VerifyEmailResponse } from '@/graphql/types';
import { ApolloClientName } from '@/config/apolloClient';
import config from '@/config/config';
import { APP_ROUTES } from '@/config/constants';
import { loginEmailVar, showMagicLinkSuccessVar } from '@/graphql/state';

export const useLogin = () => {
  const [verifyEmailQuery] = useLazyQuery<VerifyEmailResponse>(VERIFY_EMAIL);
  const [requestMagicLinkMutation] = useMutation<RequestMagicLinkResponse>(
    REQUEST_MAGIC_LINK_MUTATION
  );
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const requestMagicLink = async (email: string): Promise<boolean> => {
    try {
      const userEmail = decodeURIComponent(email);
      const response = await verifyEmailQuery({
        errorPolicy: 'all',
        variables: {
          input: {
            email: userEmail,
          },
        },
        context: {
          clientName: ApolloClientName.AccountsBff,
        },
      });
      const verifyEmail = response.data?.verifyEmail;
      if (verifyEmail) {
        let userDestination = '';
        if (!verifyEmail.scopes.includes('parent')) {
          userDestination = config.REACT_APP_ACCOUNTS_URL;
        }

        const destination = userDestination
          ? decodeURIComponent(userDestination)
          : config.REACT_APP_BASE_URL;

        const { data: magicLinkData } = await requestMagicLinkMutation({
          errorPolicy: 'all',
          variables: {
            input: {
              email,
              destination,
            },
          },
          context: {
            clientName: ApolloClientName.AccountsBff,
          },
        });

        const magicLinkSuccessful = magicLinkData?.requestMagicLink.success;
        const newEmail = response.data?.verifyEmail.email || userEmail;
        const uriEmail = encodeURIComponent(newEmail);
        if (magicLinkSuccessful) {
          if (pathname.includes(APP_ROUTES.login)) {
            navigate(`${APP_ROUTES.magicLinkSuccess}?email=${uriEmail}`);
          } else {
            showMagicLinkSuccessVar(true);
            loginEmailVar(newEmail);
          }
          return true;
        }
      }
    } catch (err) {
      console.log('error=>', err);
    }
    return false;
  };

  return {
    requestMagicLink,
  };
};
